export enum productTypeFormFields {
  nameEn = 'nameEn',
  nameAr = 'nameAr',
  descriptionEn = 'descriptionEn',
  descriptionAr = 'descriptionAr',
  fee = 'fee',
  scoreDependent = 'scoreDependent',
  isCustom = 'isCustom',
  disabled = 'disabled',
  files = 'files',
  indexFunds = 'indexFunds',
  productStatus = 'productStatus',
}
